'use client';

import { ApolloNextAppProvider, ApolloClient, InMemoryCache } from '@apollo/client-integration-nextjs';
import UploadHttpLink from 'apollo-upload-client/UploadHttpLink.mjs';
import config from '../config';

// Shared Apollo cache configuration
const possibleTypes = {
  NotificationRecord: [
    'Event',
    'EventComment',
    'EventMember',
    'EventInvite',
    'EventSeries',
    'GroupMember',
    'GroupPost',
    'GroupComment',
    'GroupInvite',
    'UserFollow',
  ],
  EventOwner: ['User', 'Group'],
};

// Factory function to create Apollo Client for App Router
function makeClient() {
  const link = new UploadHttpLink({
    uri: config().universal.graphqlUri,
    credentials: 'same-origin',
    // Apollo Server 3.x CSRF prevention header
    headers: {
      'apollo-require-preflight': 'true'
    }
  });

  return new ApolloClient({
    cache: new InMemoryCache({
      possibleTypes,
      typePolicies: {
        EventPermissions: { merge: true },
        EventSeriesPermissions: { merge: true },
        GroupPermissions: { merge: true },
        GroupPostPermissions: { merge: true },
        ImageUploadPermissions: { merge: true },
      },
    }),
    link,
  });
}

export function ApolloWrapper({ children }: { children: React.ReactNode }) {
  return (
    <ApolloNextAppProvider makeClient={makeClient}>
      {children}
    </ApolloNextAppProvider>
  );
}

